export const STUDENT_ROLE_CONFIG = {
  "student": {  // match your actual role_slug
    notification: {
      view: "/student/admin/notification/view",
      goback: "/student/admin/notifications",
      gobackhome: "/student/start-your-quest"
    },
  },
  teacher: {
    notification: {
      view: "/teacher/reciever/notification/view",
      goback: "/teacher/reciever/notifications",
      gobackhome: "/teacher/dashboard"
    },
  },
  parent: {
    notification: {
      view: "/school-parent/reciever/notification/view",
      goback: "/school-parent/reciever/notifications",
      gobackhome: "/school-parent/dashboard"
    },
  },
};